'use client';

import * as React from 'react';
import { Dashboard } from '@/shared/i18n';
import { Button, Typography } from '@mui/material';
import { RocketLaunchRounded } from '@mui/icons-material';
import { EventBus } from '@/shared/utils';
import { DashboardEventKeys, DashboardEvents } from '../../events';

interface ExploreMoreProps {
  eventBus: EventBus<DashboardEvents>;
  isSubscribed: boolean;
  isLoading: boolean;
  dict: Dashboard;
  url: string;
}

const ExploreMore: React.FC<ExploreMoreProps> = ({
  eventBus,
  isSubscribed,
  isLoading,
  dict,
  url,
}) => {
  if (isLoading) return null;
  return (
    <div className="max-w-[800px] m-auto">
      <div className="rounded-xl bg-paper/50 p-4 md:p-8 text-center sm:text-left w-full">
        <div className="flex flex-wrap sm:flex-nowrap gap-8">
          <div className="w-full lg:w-auto">
            <Typography variant="h2" className="mb-1" component="h2">
              Vuoi di più{isSubscribed ? '' : '?'}
            </Typography>
            <Typography variant="body-500" component="p">
              {isSubscribed
                ? 'Esplora il catalogo per scoprire nuovi contenuti adatti a te'
                : 'Abbonati a Vibly per accedere a tutti i contenuti senza nessuna limitazione'}
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              className="gap-2 flex-none mt-4"
              onClick={() =>
                eventBus.emit(DashboardEventKeys.redirects.to, { url, isExternalPage: false })
              }
            >
              <RocketLaunchRounded />
              <Typography variant="button-l">
                {isSubscribed ? 'Vai al Catalogo' : 'Abbonati'}
              </Typography>
            </Button>
          </div>
          <img
            src="/assets/images/dashboard/banner.png"
            alt="banner-image"
            className="w-[280px] h-auto mx-auto lg:mr-0"
          />
        </div>
      </div>
    </div>
  );
};

export default ExploreMore;
